/**
 * 存储类型工具函数
 */

/**
 * 将英文存储类型转换为中文显示名称
 * @param storageType 存储类型（TEMPORARY、NORMAL、LONG_TERM）
 * @returns 中文显示名称
 */
export const getStorageTypeDisplayName = (storageType?: string): string => {
  if (!storageType) {
    return '';
  }
  
  const typeMap: Record<string, string> = {
    'TEMPORARY': '临时',
    'NORMAL': '普通',
    'LONG_TERM': '长期'
  };
  
  return typeMap[storageType.toUpperCase()] || storageType;
};

/**
 * 获取存储类型的描述信息
 * @param storageType 存储类型
 * @returns 描述信息
 */
export const getStorageTypeDescription = (storageType?: string): string => {
  if (!storageType) {
    return '';
  }
  
  const descriptionMap: Record<string, string> = {
    'TEMPORARY': '保存 1 天',
    'NORMAL': '保存 180 天',
    'LONG_TERM': '长期保存'
  };
  
  return descriptionMap[storageType.toUpperCase()] || '';
};

